export default __webpack_public_path__ + "static/media/alliance.b58deb48.png";